<template>
  <div style="background-color: #ffc728">
    <b-sidebar
      :id="sidebarId"
      centered
      :width="width"
      ref="cornerInsights"
      :right="true"
      no-header
      @shown="handleShownDataRefresh"
    >
      <b-container>
        <corner-insights
          ref="insights"
          :corner="corner"
          :user="user"
          :listing="listingForCorner"
        />
      </b-container>
      <template #footer="{ hide }">
        <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <div class="mr-auto">
            Patent Pending
          </div>
          <b-button size="sm" @click="hide">Close</b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import CornerInsights from "@/components/cornerInsights";
import { mapGetters } from "vuex";
export default {
  name: "ToolInsights",
  components: {
    CornerInsights
  },
  props: {
    sidebarId: {
      type: String,
      default: null
    },
    publishingId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      publishings: "user/listPublishings",
      getLocalPublishingWithId: "user/getLocalPublishingWithId"
    }),
    isManageable() {
      return this.isLocalPublishingCorner ? true : false;
    },
    publishing() {
      if (
        !this.isLocalPublishingCorner &&
        this.cornerPublishingListingPublished
      ) {
        return this.cornerPublishingListingPublished.doc;
      }
      return this.publishings && Array.isArray(this.publishings)
        ? this.publishings.filter(aPublishing => {
            return aPublishing.id === this.publishingId;
          })[0]
        : null;
    },
    listingForCorner() {
      return this.activePublishings.filter(p => {
        //console.log(`ID1 ${p.id} ${this.publishing.id}`);
        return p.id === this.publishing.id;
      })[0];
    },
    corner() {
      //structure for corner
      return {
        doc: this.publishing
      };
    },
    width() {
      return this.mini ? "20%" : "80%";
    }
  },
  data() {
    return {
      activePublishings: [],
      listPublishings: []
    };
  },
  methods: {
    handleShownDataRefresh() {
      //this.$refs.insights.getPublishingStats(this.publishing);
      this.getPublishingStats(this.publishing);
    },
    getPublishingStats(publishing) {
      //publishing.status == "active") {
      this.activePublishings = [];
      let existingPublishing = this.listPublishings.filter(
        lPublishing => lPublishing.id === publishing.id
      );
      if (existingPublishing.length == 0) {
        this.$store
          .dispatch("listings/getListPublishings", publishing.id)
          .then(data => {
            this.activePublishings = data;
            console.log("this.activePublishings => ", this.activePublishings);
            this.listPublishings.push(data);
          })
          .catch(error => {
            console.log("Error getting document: ", error);
          });
      } else {
        this.activePublishings = existingPublishing[0];
      }
    },
    updateCrews(crews) {
      console.log(crews);
      this.crews = crews;
    },
    closeAddCrew() {
      this.show.sidePanel = "DEFAULT";
    },
    hideAllPopups() {
      this.show.status_dropdown = false;
    },
    overlayClicked() {
      this.show.status_dropdown = false;
      this.show.addPopup = false;
      this.show.overlay = false;
      this.show.editPopup = false;
      console.log(this.show.overlay);
    },
    toogledropDown() {
      this.show.status_dropdown = !this.show.status_dropdown;
      this.toogleOverlay();
    },
    toogleAddPopup() {
      this.toogleOverlay();
      this.show.addPopup = !this.show.addPopup;
      console.log(this.show.addPopup);
    },
    toogleEditPopup() {
      this.toogleOverlay();
      this.show.editPopup = !this.show.editPopup;
    },
    toogleOverlay() {
      this.show.overlay = !this.show.overlay;
    },
    localPublishingWithId(pubId) {
      return this.getLocalPublishingWithId(pubId);
    },
    handleRefreshPublishing() {
      console.log("updating publishings-toolCornerEditorr");
      this.$emit("refresh-publishings");
    },
    handleSidebarChange(change) {
      console.log(`Change is ${change}`);
      //TODO can be improved to update on either close or open and not both
      console.log(`The publishing Id is ${this.publishingId}`);
      this.isLocalPublishingCorner = true;
    }
  },
  filters: {
    reverse(value) {
      return value.slice().reverse();
    }
  }
};
</script>

<style lang="scss" scoped>
.corner {
  //background-color: #ffc728;
  padding-top: 125px;
  padding-bottom: 60px;
  @media (min-width: 767px) {
    padding-top: 130px;
  }
  .horizontal-line {
    border-top: 1px solid #ddd;
  }
  .author-wrapper {
    position: relative;
    z-index: 9;
    .other-way {
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 20px;
      position: fixed;
      top: 145px;
      right: 96px;
      .txt {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.03em;
        color: #8d99a0;
      }
      .acts {
        margin-top: 16px;
        display: flex;
        .ico {
          cursor: pointer;
          margin-right: 24px;
          &:hover {
            transform: scale(1.07);
          }
        }
      }
    }
    .author-card {
      position: fixed;
      left: 100px;
      top: 50%;
      transform: translateY(-50%);
      width: 196px;
      z-index: 4;
      .author {
        .profile {
          cursor: pointer;
          display: grid;
          grid-template-columns: 36px 1fr;
          grid-column-gap: 11px;
          align-items: center;
          margin-bottom: 22px;
          img {
            height: 36px;
            width: 36px;
            border-radius: 50%;
            object-fit: cover;
          }
          .name {
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 26px;
            color: #474d52;
            margin-bottom: 0px;
          }
          .email {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.03em;
            text-decoration-line: underline;
            color: #8d99a0;
          }
        }
        .btn-follow {
          border: 1px solid #474d52;
          box-sizing: border-box;
          border-radius: 4px;
          width: 70px;
          height: 28px;
          padding: 0px;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #474d52;
          background-color: #fff;
          transition: 0.2s ease;
          margin-bottom: 24px;
          &:focus {
            box-shadow: none !important;
          }
          &:hover {
            background-color: #474d52;
            color: #fff;
            &:after,
            &:before {
              content: none;
            }
          }
        }
        .followed {
          width: 76px;
          color: #fff;
          background: #474d52;
        }
      }
      .stats {
        margin-top: 4px;

        .handshakes {
          height: 28px;
          margin-top: 20px;
          display: grid;
          grid-template-columns: 28px 1fr;
          grid-column-gap: 8px;
          .ico {
            &.clap {
              transform: translate(-20px, -33px);
            }
            //margin-right: 8px;
            user-select: none;

            cursor: pointer;
            position: relative;
            .animation- {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -66%) !important;
              svg {
                height: 60px;
                width: 60px;
              }
            }
          }
          .text {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 19px;
            color: #8d99a0;
            user-select: none;
          }
        }
      }
      .author-details {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
      }
    }
  }
  .wrapper {
    max-width: 728px;
    margin: 0 auto;
    padding-top: 47px;
    @media (max-width: 767px) {
      padding: 0 15px;
    }
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: 40px;
      line-height: 55px;
      color: #474d52;
      margin-bottom: 41px;
      @media (max-width: 767px) {
        font-size: 26px;
        line-height: 34px;
      }
    }
    .content {
      padding-top: 47px;
      font-size: 20px;
      color: #19191a;
      p li {
        font-style: normal;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0.03em;
        margin: 0;
      }
    }
    .tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      grid-gap: 8px;
      margin-top: 49px;
      margin-bottom: 22px;
      .tag {
        height: 42px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
  .recommended {
    margin-top: 99px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #474d52;
    margin-bottom: 24px;
  }
  .guide-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-column-gap: 32px;
    &.recommended-cards {
      margin-bottom: 66px;
    }
  }
  .recomended-tools {
    margin-top: 66px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #474d52;
    margin-bottom: 24px;
  }
  .tool {
    padding: 18px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    .first {
      display: grid;
      grid-template-columns: 32px 1fr;
      grid-column-gap: 8px;
      align-items: center;
      margin-bottom: 8px;
      img {
        height: 32px;
        width: 32px;
        object-fit: cover;
      }
      h3 {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        margin: 0;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #474d52;
      }
    }
  }
}

.show-read-more .more-text {
  display: none;
}
.btn1 {
  border: none;
  color: black;
  background: transparent;
  font-weight: 600;
}
.card {
  background-color: #ffc727;
  border-radius: 10px;
  padding: 10px;
  display: block;
  cursor: pointer;
}
.card:hover {
  background-color: #222222;
  color: #ffc727;
  padding: 10px;
  fill: #ffc727;
  transform: scale(1.05);
}

.ico-bookmark {
  margin-right: 8px;
  cursor: pointer;
  &:hover {
    transform: scale(1.07);
  }
}
.ico-share {
  cursor: pointer;
  position: relative;
  svg {
    &:hover {
      transform: scale(1.07);
    }
  }
  &:active {
    transform: none;
  }
  .share-popup {
    position: absolute;
    width: 150px;
    height: 45px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    top: 100%;
    left: 80%;
    z-index: 3;
    &:hover {
      transform: none;
    }
  }
}
</style>
